import { ComboBoxMultiTrigger } from "./ComboBoxMultiTrigger";
import { ComboBoxSingleTrigger } from "./ComboBoxSingleTrigger";
import { useComboBoxContext } from "./context";
import type { ComboBoxTriggerProps } from "./types";

export const ComboBoxTrigger = (props: ComboBoxTriggerProps = {}) => {
  const { multiple } = useComboBoxContext();

  if (multiple) {
    return <ComboBoxMultiTrigger {...props} />;
  }

  return <ComboBoxSingleTrigger {...props} />;
};
